import {
  UpdateBankAccountAliasDocument,
  UpdateBankAccountAliasMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateBankAccountAlias = () => {
  const [updateBankAccountAlias, { loading }] = useMutation(UpdateBankAccountAliasDocument, {
    extractorFn: (data) => data.bankingMutations.updateAliasBankingBankAccount,
  })

  return {
    loading,
    updateBankAccountAlias: (variables: UpdateBankAccountAliasMutationVariables) =>
      updateBankAccountAlias({ variables }),
  }
}
